/**
 * CurrencyOrTextInput — like CurrencyInput, but the value may be EITHER a
 * dollar amount OR free text. Used for the Nut Sheet trade Retail column, where
 * an operator sometimes types a note (e.g. "Auction") instead of a number.
 *
 * Numeric values display whole-dollar formatting ($1,500) when not focused and
 * the raw number when focused; string values display as-is. parseCurrencyOrText
 * decides per keystroke whether the input is a number or text, so a typed
 * number still auto-formats while letters are preserved verbatim.
 */

import React, { useState } from 'react';
import { formatCurrency, parseCurrencyOrText } from './formatters';

interface CurrencyOrTextInputProps {
  value: number | string | null;
  onChange: (v: number | string | null) => void;
  className?: string;
  disabled?: boolean;
}

export const CurrencyOrTextInput: React.FC<CurrencyOrTextInputProps> = ({
  value,
  onChange,
  className,
  disabled,
}) => {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState<string>('');

  const display = focused
    ? draft
    : value == null
      ? ''
      : typeof value === 'number'
        ? formatCurrency(value)
        : value;

  return (
    <input
      type="text"
      value={display}
      onFocus={() => {
        setFocused(true);
        setDraft(value == null ? '' : String(value));
      }}
      onBlur={() => setFocused(false)}
      onChange={(e) => {
        setDraft(e.target.value);
        onChange(parseCurrencyOrText(e.target.value));
      }}
      className={className}
      disabled={disabled}
    />
  );
};
